/* eslint-disable @typescript-eslint/no-explicit-any */
import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"

import { DynamicTypeOptions } from "json-api-serializer"

export const attachmentEntitiesResponseTransformer = createResponseTransformer(
  json => {
    const deserialized = serializer.deserialize(
      { type: (data: { type: string }) => data.type } as DynamicTypeOptions,
      transformJsonApiResponse(json)
    )
    return {
      entities: deserialized,
      count: (json as any).meta?.count ?? 0
    }
  }
)
